<template>
  <div>
    <div class="header">
      <SearchBar @search="getAllotList" @openForm="openForm" />
    </div>

    <el-table
      v-loading="listLoading"
      :data="tableData"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" width="50" label="编号">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column>

      <el-table-column label="姓名" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.ququestUser.nickName) }}
        </template>
      </el-table-column>

      <el-table-column label="角色" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.ququestUser.roleName }}</span>
        </template>
      </el-table-column>

      <el-table-column label="所属楼盘" align="center">
        <template slot-scope="scope">
          {{ scope.row.house.houseName }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="openForm('编辑客服', scope.row)"
            v-if="roleList[path].includes('_Update')"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="deleteItem(scope.row.custSerId)"
            v-if="roleList[path].includes('_Delete')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 页码 -->
    <Pagination ref="Pagination" />

    <!-- 表单对话框 -->
    <Form ref="setForm" />
  </div>
</template>

<script>
const Form = () => import('./form'); // 表单
import Pagination from '@/components/Pagination';
import { deleteCustSerApi, getCustSerApi } from '@/api/allot.js';
import { getToken } from '@/utils/token';
import { mapGetters } from 'vuex';
import SearchBar from './searchBar';
import { decrypt } from '@/utils/encryp';
export default {
  name: 'allotAppMain',
  components: {
    Pagination,
    SearchBar,
    Form,
  },
  inject: ['reload'],
  data() {
    return {
      listLoading: false,
      tableData: [],
      name: '',
      pageIndex: '',
      pageSize: '',
    };
  },
  created() {
    this.getAllotList();
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },
  watch: {
    paginObj: 'getAllotList',
  },
  methods: {
    // 处理解密
    handledecrypt(str) {
      if (!str) return;
      return decrypt(str);
    },
    // 获取数据的方法
    async getAllotList(obj = {}) {
      const houseId = JSON.parse(getToken('userInfo')).houseId;
      try {
        this.listLoading = true;
        await getCustSerApi({
          houseId,
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          ...obj,
        }).then((res) => {
          let { dataList, totalCount, pageSize, pageIndex } = res.data;
          this.tableData = dataList;
          this.pageIndex = pageIndex;
          this.pageSize = pageSize;
          this.listLoading = false;
          this.$refs.Pagination.totalCount = totalCount;
          this.$refs.Pagination.pageSize = pageSize;
          this.$refs.Pagination.pageIndex = pageIndex;
        });
      } catch (e) {
        window.console.log(e);
      }
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 打开表单
    openForm(val, row = null) {
      if (row !== null) this.$refs.setForm.fromAppMainData = row;
      this.$refs.setForm.dialogTitle = val;
      this.$refs.setForm.dialogFormVisible = true;
    },

    // 单条删除
    async deleteItem(id) {
      try {
        this.$confirm('是否狠心删除该数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        }).then(async () => {
          await deleteCustSerApi(id).then((res) => {
            if (res.code !== 200) return;
            this.$message.success('删除成功！');
            this.reload();
          });
        });
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .search {
    display: flex;
    width: 800px;

    .search-input {
      margin: 0 10px;
      width: 300px;
    }

    .search-picker {
      width: 250px;
    }

    .search-select {
      margin-right: 10px;
    }
  }

  button {
    height: 40px;
  }
}
.btn {
  display: flex;
  align-items: center;
}
/deep/ .el-checkbox__input {
  margin-left: 10px;
}
</style>
